// @flow
import React, { Component } from 'react';
import { Link } from 'react-router';
import entries from 'object.entries';

import style from './style.css';

type State = {
  showDropdown: boolean;
};

type Props = {
  index: Object;
  version: string;
  pathname: string;
};

export default class MobileDropdown extends Component<void, Props, State> {
  state = {
    showDropdown: false
  };

  showDropdown = () => {
    this.setState({
      showDropdown: true,
    });
  }

  hideDropdown = () => {
    this.setState({
      showDropdown: false,
    });
  }

  toggleDropdown = (evt?: Event & { target: HTMLElement }) => {
    const { showDropdown } = this.state;
    if (evt) {
      evt.target.blur();
    }
    this.setState({
      showDropdown: !showDropdown,
    });
  }

  handleKeypress = (evt: Event & { which: number }) => {
    if (evt.which === 32 || evt.which === 13) {
      this.toggleDropdown();
    }
  }

  render() {
    const { index, pathname, version } = this.props;
    const { showDropdown } = this.state;
    let activeSection;
    let type;
    if (pathname.match(/\/guide\//)) {
      activeSection = index.guide;
      type = 'guide';
    } else if (pathname.match(/\/api\//)) {
      activeSection = index.api;
      type = 'api';
    }
    let typeEntries;
    let currentEntry;
    if (type) {
      typeEntries = entries(activeSection);
      for (let i = 0; i < typeEntries.length; i += 1) {
        const entry = typeEntries[i];
        const title = type === 'guide' ? entry[1] : entry[1].name;
        if (pathname.match(entry[0])) {
          currentEntry = title;
        }
      }
    }
    return (
      <div
        className={
          `${style.dropdownContainer} ${activeSection ? style.show : ''}`
        }
      >
        <a
          className={`${style.currentPage} ${showDropdown ? style.active : ''}`}
          onClick={this.toggleDropdown}
          onKeyPress={this.handleKeypress}
          tabIndex="0"
        >
          {currentEntry}
        </a>
        <ul
          aria-hidden={!showDropdown}
          className={`${style.options} ${showDropdown ? style.show : ''}`}
          tabIndex={showDropdown ? '' : -1}
        >
          {typeEntries && typeEntries.map((
            [slug, title]
          ) => { // eslint-disable-line arrow-body-style
            return (
              <li
                className={style.option}
                key={slug}
              >
                <Link
                  aria-hidden={!showDropdown}
                  onClick={this.hideDropdown}
                  tabIndex={showDropdown ? '' : -1}
                  to={`/docs/${version}/${String(type)}/${slug}`}
                >
                  {type === 'guide' ? title : title.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileDropdown/index.jsx